import { createContext, RefObject } from 'react';

export interface Breadcrumb {
  customBreadcrumbItem?: JSX.Element
  title: string;
  path: string;
}

export interface BreadcrumbsContext {
  readonly setBreadcrumbs: (breadcrumbs: Breadcrumb[]) => void;
  readonly breadcrumbs: Breadcrumb[];
  readonly breadcrumbsContainerRef: RefObject<HTMLDivElement>;
}

export const breadcrumbsContext =
  createContext<BreadcrumbsContext | undefined>(undefined);
